<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onItemClick'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <PressDiePressingCount ref="refPressDiePressingCount" :goodsType="goodsType"/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import PressDiePressingCount from './PressDiePressingCount'

export default {
  name: 'bom-tab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: [],
      goodsType: ConstDef.구매품
    }
  },
  components: {
    DxTabPanel,
    PressDiePressingCount
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    console.log(user)
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)

    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
    onItemClick (e) {
      if (this.selectedIndex === 0) {
        this.goodsType = ConstDef.구매품
      } else {
        this.goodsType = ConstDef.다공정품
      }
      this.$refs.refPressDiePressingCount.refreshPressingCount(this.goodsType)
    }
  }
}
</script>

<style lang="scss">

</style>
